export const BATTERY_BUNDLE_TAB_ID = 'battery-bundle';
export const BATTERY_ONLY_TAB_ID = 'battery-only';

export type PublicRetrofitProductType =
  | typeof BATTERY_BUNDLE_TAB_ID
  | typeof BATTERY_ONLY_TAB_ID;
